import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ReviewTemplates = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.33319 2.49707C6.50476 2.49707 5.83319 3.16864 5.83319 3.99707V5.42006H4.5C3.67157 5.42006 3 6.09163 3 6.92006V20.9972C3 21.8256 3.67157 22.4972 4.5 22.4972H16.667C17.4954 22.4972 18.167 21.8256 18.167 20.9972V19.5742H19.5002C20.3286 19.5742 21.0002 18.9027 21.0002 18.0742V3.99707C21.0002 3.16864 20.3286 2.49707 19.5002 2.49707H7.33319ZM17.167 19.5742H7.33319C6.50476 19.5742 5.83319 18.9027 5.83319 18.0742V6.42006H4.5C4.22386 6.42006 4 6.64392 4 6.92006V20.9972C4 21.2734 4.22386 21.4972 4.5 21.4972H16.667C16.9431 21.4972 17.167 21.2734 17.167 20.9972V19.5742ZM6.83319 3.99707C6.83319 3.72093 7.05704 3.49707 7.33319 3.49707H19.5002C19.7763 3.49707 20.0002 3.72093 20.0002 3.99707V18.0742C20.0002 18.3504 19.7763 18.5742 19.5002 18.5742H7.33319C7.05704 18.5742 6.83319 18.3504 6.83319 18.0742V3.99707Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.4435 12.1111C16.0005 13.3708 14.8003 14.2737 13.3892 14.2737C12.3879 14.2737 11.4928 13.8191 10.8991 13.105L10.8991 13.1841L10.0632 13.6617C10.8391 14.6436 12.0406 15.2737 13.3892 15.2737C15.2497 15.2737 16.8301 14.0745 17.3996 12.407C17.9759 12.3281 18.4199 11.8339 18.4199 11.236C18.4199 10.5832 17.8907 10.054 17.2379 10.054C16.5851 10.054 16.056 10.5832 16.056 11.236C16.056 11.5829 16.2054 11.8949 16.4435 12.1111ZM15.8511 8.93529C15.2574 8.2405 14.3747 7.80005 13.3892 7.80005C11.8751 7.80005 10.6037 8.83969 10.2502 10.2441C10.5716 10.4553 10.7839 10.8192 10.7839 11.2326C10.7839 11.8853 10.2547 12.4145 9.60189 12.4145C8.94911 12.4145 8.41992 11.8853 8.41992 11.2326C8.41992 10.7002 8.77189 10.25 9.25583 10.1021C9.68149 8.21191 11.3705 6.80005 13.3892 6.80005C14.7471 6.80005 15.9558 7.43888 16.7312 8.43239L15.8511 8.93529Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default ReviewTemplates
